export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7417.5594b73b.jpg";